module.exports = __webpack_public_path__ + "static/media/landing-description-photo.9c2a1354.png";